export class AuthService {
  constructor($resource, ApiService, $cookies, $state, $window) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
    this.featureUrl = this.apiService.getResourceUrl("/dashboard");
    const loginUrl = this.apiService.getResourceUrl("/account/login");
    const registerUrl = this.apiService.getResourceUrl("/account/register");
    const logoutUrl = this.apiService.getResourceUrl("/account/signout");
    this.forgotPasswordResourceUrl = this.apiService.getResourceUrl(
      "/account/forgot-password"
    );
    const updatePasswordResourceUrl = this.apiService.getResourceUrl(
      "/account/change-password"
    );
    this.resetPasswordResourceUrl = this.apiService.getResourceUrl(
      "/account/reset-password/:token"
    );

    this.loginState = false;
    this.$cookies = $cookies;
    this.$window = $window;
    this.authData = {};
    this.permissions = [];
    this.$state = $state;

    this.updatePasswordResource = this.$resource(
      updatePasswordResourceUrl,
      null,
      {
        update: {
          method: "PUT",
        },
      }
    );

    this.featuresResoures = this.$resource(this.featureUrl, null, {
      update: {
        method: "post",
      },
    });
    this.loginResource = this.$resource(loginUrl, null, {
      add: {
        method: "post",
      },
    });
    this.registerResource = this.$resource(registerUrl, null, {
      add: {
        method: "post",
      },
    });
    this.logoutResource = this.$resource(logoutUrl, null, {
      update: {
        method: "PUT",
      },
    });

    this.forgotPasswordResource = this.$resource(
      this.forgotPasswordResourceUrl,
      null,
      {
        save: {
          method: "POST",
        },
      }
    );
    this.resetPasswordResource = this.$resource(
      this.resetPasswordResourceUrl,
      null,
      {
        update: {
          method: "PUT",
        },
      }
    );
    this.loginRedirectRoute = "";
    // this.featuresList=[];
  }

  _setEmailIdObject(value) {
    return {
      email: value,
    };
  }

  _setChangePasswordObject(value) {
    return {
      oldPassword: value.currentPassword,
      newPassword: value.newPassword,
    };
  }

  _setResetPasswordObject(value) {
    return {
      password: value.newPassword,
      confirm_password: value.confirmPassword,
    };
  }

  /*
   * @method getProduct
   * @returns
   */
  getProduct() {
    return this.product;
  }

  isAuthenticated() {
    const session = this.$cookies.getObject("user");
    if (session) {
      this.authData = session;
      return true;
    } else {
      return false;
    }
  }

  getAuthorizationHeader() {
    const token = this.$cookies.get("token");
    let authHeader = "";
    if (token) {
      authHeader = `token ${token}`;
    }
    return authHeader;
  }

  setHeader() {
    this.apiService.removeDefaultHeaders();
    const authHeader = this.getAuthorizationHeader();
    this.apiService.setDefaultHeaders(authHeader);
  }

  login(username, password) {
    const promise = this.loginResource.add({
      userName: username,
      password: password,
    }).$promise;

    return new Promise((resolve, reject) => {
      promise.then(({ details }) => {
        this.setUser(details);
        this.$cookies.put("token", details.token);
        this.$cookies.putObject("features", details.features);
        resolve();
      }, reject);
    });
  }

  register(details) {
    const promise = this.registerResource.add(details).$promise;
    return new Promise((resolve, reject) => {
      promise.then(({ details }) => {
        resolve(details);
      }, reject);
    });
  }

  setLoginRedirect(_state) {
    this.loginRedirectRoute = _state;
  }

  getLoginRedirect() {
    return this.loginRedirectRoute;
  }

  getFeatureList() {
    const promise = this.featuresResoures.get().$promise;
    return new Promise((resolve, reject) => {
      promise.then(({ details }) => {
        let _details = details.featureList;
        this.$cookies.put("logoUrl", details.logo);
        resolve(_details);
      }, reject);
    });
  }

  removeCookies() {
    this.loginState = false;
    this.$cookies.remove("user");
    this.$cookies.remove("token");
    this.$cookies.remove("features");
  }

  removeCache() {
    // remove items from local storage
    this.$window.localStorage.removeItem("breadcrumbs");
  }

  expireSession() {
    this.removeCookies();
    this.removeCache();
    this.$state.go("login");
  }

  logout() {
    this.expireSession();
    // const promise = this.logoutResource.update().$promise;

    // return new Promise((resolve, reject) => {
    //   promise.then((result) => {
    //     this.expireSession();
    //     resolve();
    //   }, reject);
    // });
  }

  setUser(data) {
    this.authData = angular.copy(data);
    this.authData.name = `${this.authData.firstName}`; //to do this.authData.name
    this.$cookies.putObject("user", this.authData);
  }

  getUser() {
    return this.$cookies.getObject("user");
  }

  getUserSettings() {
    return this.getUser().vendor_settings;
  }

  getUserRole() {
    return {
      role: this.authData.account.role,
      isAdmin:
        this.authData.account.role &&
        this.authData.account.role.indexOf("Admin") > 0
          ? true
          : false,
    };
  }

  forgotPassword(data) {
    const promise = this.forgotPasswordResource.save(
      this._setEmailIdObject(data)
    ).$promise;

    return promise
      .then((emailDetails) => {
        return emailDetails.data;
      })
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  confirmToken(token) {
    const promise = this.resetPasswordResource.get({
      token: token,
    }).$promise;

    return promise
      .then((confirmDetails) => {
        return confirmDetails.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  updatePassword(details) {
    const promise = this.updatePasswordResource.update(
      this._setChangePasswordObject(details)
    ).$promise;

    return promise
      .then((details) => {
        return details.data;
      })
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  resetPassword(token, details) {
    const promise = this.resetPasswordResource.update(
      { token: token },
      this._setResetPasswordObject(details)
    ).$promise;

    return promise
      .then((resetDetails) => resetDetails.data)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  getHeaderImagePath() {
    return this.authData && this.authData.logo
      ? this.apiService.getResourceUrl(this.authData.logo)
      : "./images/logo";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/auth/auth.service.js